/**
 * Hata sözleşmesi — PRD §10.3.
 *
 * Kasada gösterilen mesajlar sunucudan gelir; böylece "anlaşılır Türkçe"
 * kuralı (KK-305) tek yerden yönetilir ve terminal sürümleri arasında kaymaz.
 */
export const HataKodu = {
    YETERSIZ_BAKIYE: "YETERSIZ_BAKIYE",
    LIMIT_ASIMI: "LIMIT_ASIMI",
    URUN_YASAK: "URUN_YASAK",
    ADET_ASIMI: "ADET_ASIMI",
    KART_BLOKE: "KART_BLOKE",
    KART_TANIMSIZ: "KART_TANIMSIZ",
    OFFLINE_TAVAN: "OFFLINE_TAVAN",
    TEKRAR_ISLEM: "TEKRAR_ISLEM",
    // Nokta / yetki
    NOKTA_SATIS_YAPMAZ: "NOKTA_SATIS_YAPMAZ",
    NOKTA_YETKISIZ: "NOKTA_YETKISIZ",
    YETKISIZ: "YETKISIZ",
    /** Oturum sunucuda geçersiz kılınmış (sürüm/iptal) — 401, yeniden giriş ister. */
    OTURUM_GECERSIZ: "OTURUM_GECERSIZ",
    TERMINAL_AKTIF_DEGIL: "TERMINAL_AKTIF_DEGIL",
    TERMINAL_TOKEN_GECERSIZ: "TERMINAL_TOKEN_GECERSIZ",
    BULUNAMADI: "BULUNAMADI",
    // Stok
    STOK_YETERSIZ: "STOK_YETERSIZ",
    URUN_SATISTA_DEGIL: "URUN_SATISTA_DEGIL",
    STOK_KONDISYON_HATASI: "STOK_KONDISYON_HATASI",
    TRANSFER_DURUM_HATASI: "TRANSFER_DURUM_HATASI",
    /** KK-503: barkod okul içinde tekildir; başka ürüne bağlıysa sessizce çalınmaz. */
    BARKOD_KULLANIMDA: "BARKOD_KULLANIMDA",
    // Genel
    GECERSIZ_ISTEK: "GECERSIZ_ISTEK",
    CAKISMA: "CAKISMA",
    SUNUCU_HATASI: "SUNUCU_HATASI",
};
/** Kod -> varsayılan HTTP durumu (§10.3) */
export const HATA_HTTP = {
    [HataKodu.YETERSIZ_BAKIYE]: 422,
    [HataKodu.LIMIT_ASIMI]: 422,
    [HataKodu.URUN_YASAK]: 422,
    [HataKodu.ADET_ASIMI]: 422,
    [HataKodu.KART_BLOKE]: 422,
    [HataKodu.KART_TANIMSIZ]: 404,
    [HataKodu.OFFLINE_TAVAN]: 422,
    [HataKodu.TEKRAR_ISLEM]: 200,
    [HataKodu.NOKTA_SATIS_YAPMAZ]: 422,
    [HataKodu.NOKTA_YETKISIZ]: 404,
    [HataKodu.YETKISIZ]: 403,
    [HataKodu.OTURUM_GECERSIZ]: 401,
    [HataKodu.TERMINAL_AKTIF_DEGIL]: 403,
    [HataKodu.TERMINAL_TOKEN_GECERSIZ]: 403,
    [HataKodu.BULUNAMADI]: 404,
    [HataKodu.STOK_YETERSIZ]: 422,
    [HataKodu.URUN_SATISTA_DEGIL]: 422,
    [HataKodu.STOK_KONDISYON_HATASI]: 422,
    [HataKodu.TRANSFER_DURUM_HATASI]: 409,
    [HataKodu.BARKOD_KULLANIMDA]: 409,
    [HataKodu.GECERSIZ_ISTEK]: 400,
    [HataKodu.CAKISMA]: 409,
    [HataKodu.SUNUCU_HATASI]: 500,
};
/**
 * İş kuralı reddi. Bunlar beklenen sonuçlardır — 5xx değil, 4xx üretirler
 * ve kasada doğrudan kullanıcıya gösterilirler.
 */
export class IsKuraliHatasi extends Error {
    kod;
    http;
    detay;
    constructor(kod, mesaj, detay) {
        super(mesaj);
        this.name = "IsKuraliHatasi";
        this.kod = kod;
        this.http = HATA_HTTP[kod] ?? 422;
        this.detay = detay;
    }
    govde() {
        return this.detay
            ? { hata: this.kod, mesaj: this.message, detay: this.detay }
            : { hata: this.kod, mesaj: this.message };
    }
}
/** §10.3 tablosundaki kasa mesajları — parametreli üretilir. */
export const kasaMesaji = {
    yetersizBakiye: (kalan) => `Bakiye yetersiz — kalan: ${kalan}`,
    limitAsimi: (limit) => `Günlük limit doldu (${limit})`,
    urunYasak: (urunAdi) => `Bu ürün veli tarafından kısıtlanmış: ${urunAdi}`,
    adetAsimi: (urunAdi, adet) => `${urunAdi} ürününden bugün en fazla ${adet} adet alınabilir`,
    kartBloke: (zaman) => zaman
        ? `Bu kart ${zaman} tarihinde bloke edilmiştir.`
        : "Kart bloke — yönetime başvurun",
    kartTanimsiz: () => "Kart tanımlı değil",
    offlineTavan: (tavan, kalan) => `Bağlantı yokken bu karttan en fazla ${tavan} harcanabilir — kalan: ${kalan}`,
    stokYetersiz: (urunAdi, mevcut) => `${urunAdi} için yeterli sağlam stok yok (mevcut: ${mevcut})`,
    noktaSatisYapmaz: () => "Bu nokta satış yapmaz (depo)",
};
//# sourceMappingURL=hatalar.js.map